<template>
  <div class="ctotop">
    <div class="ctotop-content">
      <div class="top-icon" @click="scrollTo(0)"></div>
      <div class="wait">期待与您相见</div>
      <div class="wait-content">
        <p>为品牌提供定制化解决方案，为消费者打造完美购物体验</p>
        <p>构架起品牌与消费者之间的互通桥梁</p>
      </div>
      <div class="concat-button-line">
        <div class="concat-button" @click="toJoinUs()">加入我们</div>
        <div class="concat-button2" @click="toJoinUs()">联系我们</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "CToTop",
    methods: {
      toJoinUs(){
        this.$router.push({name:"JoinUs"})
      },
      scrollTo() {
        var scrollToTop = setInterval(function () {
          var pos = window.pageYOffset;

          if (pos > 0) {
            window.scrollTo(0, pos - 20);
          } else {
            window.clearInterval(scrollToTop);
          }
        }, 10);
      }
    }
  }
</script>

<style scoped>
  .ctotop {
    width: 100%;
    height: 400px;
    position: relative;
  }

  .ctotop-content {
    width: 1920px;
    height: 400px;
    position: absolute;
    top: 0;
    left: 50%;
    margin-left: -960px;
    background-image: url("../assets/bg9.png");
  }

  .top-icon {
    background-image: url("../assets/zs2.png");
    width: 86px;
    height: 80px;
    margin: 28px auto 0;
    cursor: pointer;
  }

  .wait {
    font-size: 36px;
    font-family: SourceHanSansCN-Normal, SourceHanSansCN;
    font-weight: 400;
    color: #333333;
    line-height: 54px;
    text-align: center;
  }

  .wait-content {
    font-size: 18px;
    font-family: SourceHanSansCN-Normal, SourceHanSansCN;
    font-weight: 400;
    color: #081457;
    line-height: 28px;
    margin-top: 19px;
    text-align: center;
    opacity: 0.5;
  }

  .concat-button-line {
    display: flex;
    justify-content: center;
    margin-top: 40px;
  }

  .concat-button {
    background-image: url("../assets/Rectangle112.png");
    width: 214px;
    height: 100px;
    line-height: 80px;
    font-size: 15px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    text-align: center;
    cursor: pointer;
  }
  .concat-button2{
    font-size: 15px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 50px;
    margin-left: 87px;
    margin-top: 15px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/CToTop.vue